const importFn = require.context('./', false, /\.vue$/);

export default {
  install(app) {
    importFn.keys().forEach((item) => {
      const component = importFn(item).default;
      app.component(component.name, component);
    });
  },
};
